import React from "react";
import styled, { css } from "styled-components";
import Loading from "../Loading";

class Info extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            colors: [],
            loading: false
        }
    }

    componentDidMount() {
        this.setState({ loading: true });

        import("../../data/countries.json")
            .then(data => {
                this.setState({
                    colors: data.default.metadata.colors,
                    loading: false
                })
            })
    }
    
    render() {
        console.log("Loading: ", this.state.loading);
        return <Container>
            <Loading isDisplayed={ this.state.loading } mode={ this.props.mode } />
            <Title>Legend</Title>
            <LegendWrapper>
                { this.state.colors.map((metadata, index) => {
                    const { color, value } = metadata;
                    return <ColorMeta key={ index }>
                        <Preview color={ color } />
                        <p>{ value }</p>
                    </ColorMeta>
                }) }
            </LegendWrapper>
            <Title>Why I don't show up?</Title>
            <Explanation>
                <li>We perform a search by location of the users using the github api.</li>
                <li>The github api only supports sorting users by the following options:
                    <ul>
                        <li>Best match</li>
                        <li>followers</li>
                        <li>Joined date</li>
                        <li>Repositories</li>
                    </ul>
                </li>
                <li>Given those options, we choose to get the list of users sorted by the number of followers.</li>
                <li>The github api is limited to only 1000 search results so we can't take into account a larger pool of users.</li>
                <li>When we receive the results back from the api, we then sort the users based on their contributions.</li>
            </Explanation>
        </Container>
    }
}

const Container = styled.div`
    width: 100%;
    padding: 8px 9px;
`

const LegendWrapper = styled.div`
    border: 1px solid grey;
    padding: 12px;
`

const ColorMeta = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 6px;
`

const Preview = styled.div`
    width: 15px;
    height: 15px;
    margin-right: 8px;
    ${ props => css`background: ${ props.color };`}
`

const Title = styled.h2`
    font-size: 18px;
    margin: 8px 0;
`

const Explanation = styled.ul`
    font-size: 15px;
    
    li {
        margin-bottom: 12px;

        ul {
            margin-top: 12px;
            li {  
                margin-left: 8px;
                margin-bottom: 4px; 
            }
        }
    }
`

export default Info;